const TableWrapper = ({ children }) => {
  return (
    <table className='w-full table-fixed text-base text-left pb-5 text-black-1 dark:text-white border-collapse'>
      {children}
    </table>
  );
};

export default TableWrapper;
